import React, { Component } from 'react';
import { IoIosApps, IoIosPaper } from "react-icons/io";

//Estilos base:
const iconStyle = { width: 20, height: 20 };

class VisualizationModeChangeButton extends Component {

    render() {
        return (
            <li className="nav-item">
                <button className="nav-link btn-magnify button-on-navbar" ref="miBoton"
                    title="Vista" data-tut="reactour__downloadSourcesResume.viewModeButton"
                    style={{ backgroundColor: "transparent", border: "none" }} onClick={this.onClick} >
                    {this.getIcon()}
                    <p>
                        <span className="d-lg-none d-md-block" style={{ marginLeft: 5 }}>
                            Modo de visualización
                        </span>
                    </p>
                </button>
            </li>
        );
    }

    getIcon = () => {
        if (this.props.icono === "IoIosApps") {
            return <IoIosApps style={iconStyle} />
        }
        else {
            return <IoIosPaper style={iconStyle} />
        }
    }

    onClick = (e) => {
        if (this.props.onClick !== undefined) {
            this.props.onClick(e);
            this.refs.miBoton.blur();
        };
    }
}

export default VisualizationModeChangeButton;